<template>
  <div class="redirect-alert-dailog col-block">
    <div class="redirect-alert-progress-container" :style="{ '--progress': (countdown.current / countdown.target * 100) + '%' }">
      <div class="redirect-alert-progress"></div>
    </div>
    <div class="redirect-alert-main-container col-block">
      <div class="redirect-alert-main-content" v-html="$t('COMPONENT.dialog.redirectAlert.___content', { target: $t(currentRegion.title), countdown: Math.ceil((countdown.target - countdown.current) / 1000) })"></div>
    </div>
    <div :style="{ height: '10px' }"></div>
    <div class="redirect-alert-setting-container col-block">
      <div class="redirect-alert-setting-block row-block">
        <div class="redirect-alert-setting-title-container row-block">
          <div class="redirect-alert-setting-title">
            <span>{{ ' (' }}</span>
            <a class="link" @click.stop="e => clearSetting()">{{ $t('COMPONENT.dialog.redirectAlert.setting.___clear') }}</a>
            <span>{{ ')' }}</span>
          </div>
        </div>
      </div>
    </div>
    <div :style="{ height: '30px' }"></div>
    <div class="redirect-alert-button-container row-block">
      <button class="cancel-outline-button auto-width-button circle-button center-block" @click="e => $emit('closeModal')">
        <span>{{ $t('COMPONENT.dialog.redirectAlert.button.___change') }}</span>
      </button>
    </div>
  </div>
</template>

<script>
import { regionOptions } from '@/constants/global/data'
import customTimer from '@/mixins/customTimer.vue'

export default {
  mixins: [
    customTimer
  ],
  props: {
    params: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      countdown: {
        target: 3000,
        current: 0,
        step: 10
      }
    }
  },
  created () {
    this.customRecursive(() => {
      this.countdown.current += this.countdown.step
      let result = this.countdown.target - this.countdown.current
      if (!result) {
        this.siteOnSelected()
      }
      return !!result
    }, this.countdown.step)
  },
  computed: {
    currentRegion () {
      return regionOptions.find(option => option.value === this.params.region)
    }
  },
  methods: {
    siteOnSelected () {
      this.params.func['siteOnSelected'](this.currentRegion, true)
    },
    clearSetting () {
      this.params.func['clearSetting']()
      this.$emit('closeModal')
    }
  }
}
</script>
